import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define a type for the slice state

// Define the initial state using that type

const initialState = {
  PersonalDetailLoading: false,
};

const personalDetailLoaderSlice = createSlice({
  name: "PersonalDetailLoading",

  initialState,
  reducers: {
    setPersonalDetailLoading: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.PersonalDetailLoading = payload;
    },
    resetPersonalDetailLoading: (state: any) => {
      state.PersonalDetailLoading = false;
    },
  },
});

export const { setPersonalDetailLoading, resetPersonalDetailLoading } =
  personalDetailLoaderSlice.actions;

export default personalDetailLoaderSlice.reducer;
